import React from 'react'
import styled from "styled-components";
import { useAccount } from "wagmi";

import Tvl from '@/components/Tvl/index'
import Dashboard from '@/components/Dashboard/index'
import { useWhiteList } from '../hooks/index.js'

export default function Home() {
  const { isConnected } = useAccount();
  const isWhiteList = useWhiteList()

  return (
    <HomeWrapper>
      <Tvl isLogin={isConnected}/>
      { isConnected && isWhiteList && <Dashboard/> }
    </HomeWrapper>
  )
}

const HomeWrapper = styled.div`

`